/**
 * @file
 * Modifying behaviour within the 
 * Reports Sidebar
 *
 */
 (function ($, Drupal) {

    'use strict';
  
    Drupal.behaviors.bootstrap_barrio_subtheme = {
      attach: function (context, settings) {
        // show the table of contents for reports, chapters, other report content 
        // when viewing on desktop, keep collapsed on load for mobile
        $(function() {
          if (window.innerWidth > 768) {
            $('.toc-links').addClass('show');
            $('.toc-toggler').attr("aria-expanded","true");
          }
        });
      }
    };
  
  
  
  })(jQuery, Drupal);
  